export default {
  namespaced: true,

  state: () => ({
    brandList: {
      data: [],
      links: {},
      meta: {},
    },
    brand: {
      district: {},
    },
    selectedCouriers: [],
    brandGrowth: {
      statistic: [],
    },
    isLoading: false,
  }),

  mutations: {
    SET_BRAND_LIST(state, payload) {
      state.brandList = payload
    },
    SET_BRAND(state, payload) {
      state.brand = payload
    },
    SET_SELECTED_COURIERS(state, payload) {
      state.selectedCouriers = payload
    },
    PUSH_SELECTED_COURIER(state, payload) {
      state.selectedCouriers.push(payload)
    },
    DELETE_SELECTED_COURIER(state, index) {
      state.selectedCouriers.splice(index, 1)
    },
    SET_BRAND_GROWTH(state, payload) {
      state.brandGrowth = payload
    },
    SET_LOADING(state, payload) {
      state.isLoading = payload
    },
  },

  actions: {
    // get
    async getBrandList({ commit }, { page = null, keyword = '', hasSearch = false } = {}) {
      try {
        if (!hasSearch) commit('SET_LOADING', true)
        const url = `/v1/admin/merchants?filter[name]=${keyword}`

        const response = await this._vm.$http.get(url, { params: { page } })

        if (!hasSearch) commit('SET_BRAND_LIST', response.data)
        if (!hasSearch) commit('SET_LOADING', false)

        return response.data
      } catch (error) {
        if (!hasSearch) commit('SET_LOADING', false)
        return error
      }
    },
    async getBrand({ commit }, { id }) {
      try {
        const url = `/v1/admin/merchants/${id}`

        const response = await this._vm.$http.get(url)

        commit('SET_BRAND', response.data.data)
        commit('SET_SELECTED_COURIERS', response.data.data.courier_merchants)

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
        return error
      }
    },
    async getBrandProfileMe({ commit }) {
      try {
        const url = '/v1/admin/merchant'

        const response = await this._vm.$http.get(url)

        commit('SET_BRAND', response.data.data)
        commit('SET_SELECTED_COURIERS', response.data.data.courier_merchants)

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Memuat Data!',
        }, { root: true })
        return error
      }
    },
    // create
    async createBrandProfile({ commit }, data) {
      try {
        const url = '/v1/admin/merchants'

        const formData = new FormData()
        formData.append('image', data.imageFile)
        formData.append('name', data.name)
        formData.append('email', data.email)
        formData.append('password', data.password)
        formData.append('order', data.order)
        formData.append('phone', data.phone)
        formData.append('description', data.description)
        formData.append('is_active', data.is_active)
        formData.append('is_open', data.is_open)

        const response = await this._vm.$http.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Brand!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Brand!',
        }, { root: true })

        return error
      }
    },
    async updateBrandAddress({ commit }, { data, brandId }) {
      try {
        const url = `/v1/admin/merchants/${brandId}/address`
        const response = await this._vm.$http.put(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Alamat Brand!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Alamat Brand!',
        }, { root: true })

        return error
      }
    },
    async updateBrandPickup({ commit }, { data, brandId }) {
      try {
        const url = `/v1/admin/merchants/${brandId}/pickup`
        const response = await this._vm.$http.put(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Informasi Pickup!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Informasi Pickup!',
        }, { root: true })

        return error
      }
    },
    async updateBrandPickupMe({ commit }, { data }) {
      try {
        const url = '/v1/admin/merchant/pickup'
        const response = await this._vm.$http.put(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Informasi Pickup!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Informasi Pickup!',
        }, { root: true })

        return error
      }
    },
    // edit
    async updateBrandProfile({ commit }, { data, brandId }) {
      try {
        const url = `/v1/admin/merchants/${brandId}`

        const formData = new FormData()
        if (data.imageFile) formData.append('image', data.imageFile)
        formData.append('name', data.name)
        formData.append('email', data.email)
        formData.append('password', data.password)
        formData.append('order', data.order ? data.order : '')
        formData.append('phone', data.phone)
        formData.append('description', data.description)
        formData.append('is_active', data.is_active)
        formData.append('is_open', data.is_open)
        formData.append('is_gift_wrap_enabled', data.is_gift_wrap_enabled ? 1 : 0)

        if (data.close_started_at) formData.append('close_started_at', data.close_started_at)
        if (data.close_ended_at) formData.append('close_ended_at', data.close_ended_at)
        if (data.close_desc) formData.append('close_desc', data.close_desc)

        formData.append('_method', 'PUT')

        const response = await this._vm.$http.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Brand!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Brand!',
        }, { root: true })

        throw new Error(error.message)
      }
    },
    async pushCourier({ commit }, { data, brandId }) {
      try {
        const url = `/v1/admin/merchants/${brandId}/courier`
        const response = await this._vm.$http.post(url, { courier_id: data.id })

        const newData = response.data.data.courier_merchants.find(el => el.courier_id === data.id)

        commit('PUSH_SELECTED_COURIER', newData)
        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Kurir!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Kurir!',
        }, { root: true })

        return error
      }
    },
    async deleteCourier({ commit }, { index, data, brandId }) {
      try {
        const url = `/v1/admin/merchants/${brandId}/courier/${data.id}`
        const response = await this._vm.$http.delete(url)

        commit('DELETE_SELECTED_COURIER', index)
        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menghapus Kurir!',
        }, { root: true })

        return response
      } catch (error) {
        const code = error.response.status
        commit('response/SET_ERROR', {
          message: code === 400 ? error.response.data.message : 'Gagal Menghapus Kurir!',
        }, { root: true })

        return error
      }
    },
    async getBrandGrowth({ commit }, { startDate, endDate }) {
      try {
        const url = `/v1/backoffice/diagram/merchant_registration?filter[start_date]=${startDate}&filter[end_date]=${endDate}`

        const response = await this._vm.$http.get(url)

        commit('SET_BRAND_GROWTH', response.data.data)

        return response.data.data
      } catch (error) {
        throw new Error(error)
      }
    },
    // edit profile
    async updateBrandProfileMe({ commit }, { data }) {
      try {
        const url = '/v1/admin/merchant/profile'

        const formData = new FormData()
        if (data.imageFile) formData.append('image', data.imageFile)
        formData.append('name', data.name)
        formData.append('email', data.email)
        formData.append('password', data.password)
        formData.append('order', data.order ? data.order : '')
        formData.append('phone', data.phone)
        formData.append('description', data.description)
        formData.append('is_active', data.is_active)
        formData.append('is_open', data.is_open)
        formData.append('is_gift_wrap_enabled', data.is_gift_wrap_enabled ? 1 : 0)

        if (data.close_started_at) formData.append('close_started_at', data.close_started_at)
        if (data.close_ended_at) formData.append('close_ended_at', data.close_ended_at)

        formData.append('close_desc', data.close_desc)
        formData.append('_method', 'PUT')

        const response = await this._vm.$http.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Profil!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Profil!',
        }, { root: true })

        throw new Error(error.message)
      }
    },
    async updateBrandAddressMe({ commit }, { data }) {
      try {
        const url = '/v1/admin/merchant/address'
        const response = await this._vm.$http.put(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Alamat!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Mengubah Alamat!',
        }, { root: true })

        return error
      }
    },
    async pushCourierMe({ commit }, { data }) {
      try {
        const url = '/v1/admin/merchant/courier'
        const response = await this._vm.$http.post(url, { courier_id: data.id })

        const newData = response.data.data.courier_merchants.find(el => el.courier_id === data.id)

        commit('PUSH_SELECTED_COURIER', newData)
        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Kurir!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Kurir!',
        }, { root: true })

        return error
      }
    },
    async deleteCourierMe({ commit }, { index, data }) {
      try {
        const url = `/v1/admin/merchant/courier/${'del'}/${data.id}`
        const response = await this._vm.$http.delete(url)

        commit('DELETE_SELECTED_COURIER', index)
        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menghapus Kurir!',
        }, { root: true })

        return response
      } catch (error) {
        const code = error.response.status
        commit('response/SET_ERROR', {
          message: code === 400 ? error.response.data.message : 'Gagal Menghapus Kurir!',
        }, { root: true })

        return error
      }
    },

    async syncCourierServices({ commit }, { merchantId, serviceIds }) {
      try {
        const url = `/v1/admin/merchants/${merchantId}/courier-services/sync`
        const payload = { courier_service_ids: serviceIds }
        const response = await this._vm.$http.post(url, payload)

        commit('response/SET_SUCCESS', {
          message: 'Layanan kurir berhasil diperbarui!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal memperbarui layanan kurir!',
        }, { root: true })

        return error
      }
    },

    async changePassword({ commit }, { idBrand, data }) {
      try {
        const url = `/v1/admin/merchants/${idBrand}/set-password`
        const response = await this._vm.$http.put(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Mengubah Password Brand!',
        }, { root: true })

        return response
      } catch (error) {
        const code = error.response.status
        commit('response/SET_ERROR', {
          message: code === 400 ? error.response.data.message : 'Gagal Mengubah Password Brand!',
        }, { root: true })

        return error
      }
    },
    async setPassword({ commit }, { data }) {
      try {
        const url = '/v1/reset-password'
        const response = await this._vm.$http.post(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil! password Anda telah diatur ulang.',
        }, { root: true })

        return response
      } catch (error) {
        const code = error.response.status
        commit('response/SET_ERROR', {
          message: code === 400 || code === 422 ? error.response.data.message : 'Gagal mengatur ulang password!',
        }, { root: true })

        throw new Error(error)
      }
    },
    async resetPassword({ commit }, { email }) {
      try {
        const url = '/v1/forgot-password'
        const response = await this._vm.$http.post(url, { email })

        commit('response/SET_SUCCESS', {
          message: 'Berhasil mengirim tautan reset password.',
        }, { root: true })

        return response
      } catch (error) {
        const code = error.response.status
        commit('response/SET_ERROR', {
          message: code === 400 ? error.response.data.message : 'Gagal mengirim tautan reset password!',
        }, { root: true })

        return error
      }
    },
  },
}
